'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildPicassoPreviewSerializer = exports.buildLayerCreatorLocalState = exports.buildBlueprintLocalState = exports.buildMediaActionURLWithID = exports.buildExportJobActionURL = exports.buildMediaFBActionURL = exports.buildMediaActionURLForAeFiles = exports.buildMediaActionURLForGuides = exports.buildMediaActionURLForThumbnails = exports.buildLayerSchemaCascaderOptions = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _reselect = require('reselect');

var _generic = require('../../../helpers/generic');

var _serializers = require('../../../store/blueprint/serializers');

var _constants = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildFileUploadObj = function buildFileUploadObj(url) {
  return {
    uid: (0, _generic.uuidv4)(),
    name: (0, _generic.getImageNameFromURL)(url),
    status: 'done',
    url: url
  };
};

var buildLayerSchemaCascaderOptions = exports.buildLayerSchemaCascaderOptions = (0, _reselect.createSelector)(function (state) {
  return state[_constants.STORE_NAMESPACE].blueprints.layerSchema;
}, function (layerSchema) {
  var options = [];
  var categories = (0, _keys2.default)(layerSchema);
  categories.forEach(function (layer, parentIndex) {
    options.push({
      value: layer,
      label: layer,
      children: []
    });
    var layers = layerSchema[layer];
    layers.forEach(function (layer) {
      options[parentIndex].children.push({
        label: layer.label,
        value: layer.contentType
      });
    });
  });
  return options;
});

var buildMediaActionURLForThumbnails = exports.buildMediaActionURLForThumbnails = (0, _reselect.createSelector)(function (state) {
  return state.session.ENDPOINTS.palette_api_url;
}, function (paletteAPIURL) {
  return paletteAPIURL + '/media/upload?subFolder=PREVIEWS';
});

var buildMediaActionURLForGuides = exports.buildMediaActionURLForGuides = (0, _reselect.createSelector)(function (state) {
  return state.session.ENDPOINTS.palette_api_url;
}, function (paletteAPIURL) {
  return paletteAPIURL + '/media/upload?subFolder=GUIDES';
});

var buildMediaActionURLForAeFiles = exports.buildMediaActionURLForAeFiles = (0, _reselect.createSelector)(function (state) {
  return state.session.ENDPOINTS.palette_api_url;
}, function (paletteAPIURL) {
  return paletteAPIURL + '/media/upload?subFolder=AFTER_EFFECTS';
});

var buildMediaFBActionURL = exports.buildMediaFBActionURL = (0, _reselect.createSelector)(function (state) {
  return state.session.ENDPOINTS.palette_api_url;
}, function (paletteAPIURL) {
  return paletteAPIURL + '/media/upload-facebook';
});

var buildExportJobActionURL = exports.buildExportJobActionURL = (0, _reselect.createSelector)(function (state) {
  return state.session.ENDPOINTS.palette_api_url;
}, function (state) {
  return state.record.id;
}, function (paletteAPIURL, id) {
  return paletteAPIURL + '/export-jobs/' + id + '/upload-zip';
});

var buildMediaActionURLWithID = exports.buildMediaActionURLWithID = (0, _reselect.createSelector)(function (state) {
  return state.session.ENDPOINTS.palette_api_url;
}, function (state) {
  return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
}, function (paletteAPIURL, blueprint) {
  if (!paletteAPIURL || !blueprint) return '';
  return paletteAPIURL + '/media/upload/' + blueprint.id;
});

var buildBlueprintLocalState = exports.buildBlueprintLocalState = (0, _reselect.createSelector)(function (blueprint) {
  return blueprint;
}, function (blueprint) {
  var parsedBlueprint = (0, _assign2.default)({}, blueprint);

  if (blueprint && blueprint.previewUrl) (0, _assign2.default)(parsedBlueprint, { thumbnailFileList: [buildFileUploadObj(blueprint.previewUrl)] });
  if (blueprint && blueprint.guideUrl) (0, _assign2.default)(parsedBlueprint, { guideFileList: [buildFileUploadObj(blueprint.guideUrl)] });
  if (blueprint && blueprint.aeFileUrl) (0, _assign2.default)(parsedBlueprint, { aeFileList: [buildFileUploadObj(blueprint.aeFileUrl)] });

  return parsedBlueprint;
});

var buildLayerCreatorLocalState = exports.buildLayerCreatorLocalState = (0, _reselect.createSelector)(function (blueprint) {
  return blueprint;
}, function (blueprint) {
  var layerTemplates = blueprint.layerTemplates;

  if (layerTemplates.length === 0) return null;
  var buildBasedOnContentType = function buildBasedOnContentType(contentType, validators) {
    switch (contentType) {
      case 'TEXT':
        {
          var validator = validators.find(function (item) {
            return item.type === 'CHARACTER_COUNT_VALIDATOR';
          });
          return {
            characterCount: validator ? validator.args : 1
          };
        }
      case 'COLOR':
        return {
          colours: validators[0].args.map(function (item) {
            return { id: (0, _generic.uuidv4)(), hex: item };
          })
        };
      case 'VIDEO':
      case 'IMAGE':
      case 'AUDIO':
        return {
          media: validators[0].args.map(function (item) {
            return buildFileUploadObj(item);
          })
        };
      default:
        return null;
    }
  };

  return layerTemplates.map(function (item) {
    return (0, _extends3.default)({
      id: item.id,
      contentType: item.contentType,
      enableTitleEdit: false,
      title: item.title,
      tooltip: item.tooltip,
      enableUserMedia: item.enableUserMedia
    }, buildBasedOnContentType(item.contentType, item.validators));
  });
});

var buildPicassoPreviewSerializer = exports.buildPicassoPreviewSerializer = (0, _reselect.createSelector)(function (state) {
  return state;
}, function (state) {
  return function () {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var blueprint = state[_constants.STORE_NAMESPACE].blueprints.blueprint;
    var user = state.session.user;
    return (0, _assign2.default)({}, {
      blueprintId: blueprint.id,
      organizationId: blueprint.organizationId,
      userId: user.id,
      values: [(0, _serializers.VariationSerializer)(item)]
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/store/blueprint/selectors/index.js
// module id = 3912
// module chunks = 5 6 7 8